export const config = {
  /**
   * Find your project ID and dataset in `sanity.json` in your studio project.
   * These are considered “public”, but you can use environment variables
   * if you want differ between local dev and production.
   *
   * https://nextjs.org/docs/basic-features/environment-variables
   **/
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
  projectId: process.env.NEXT_PUBLIC_SANITY_ProjectId || '',
  apiVersion: process.env.NEXT_PUBLIC_SANITY_API_Version || '',
  /**
   * NO TOKEN HERE. This config is imported by lib/sanity.js (urlFor,
   * PortableText, preview hooks), which UI components import, so every
   * value in this object is bundled into the client and readable by
   * anyone. The dataset is public-read, so reads need no token; the
   * server clients add a server-only one in lib/sanity.server.js.
   */
  useCdn: false,
  /**
   * Set useCdn to `false` if your application require the freshest possible
   * data always (potentially slightly slower and a bit more expensive).
   * Authenticated request (like preview) will always bypass the CDN
   **/
  // useCdn: process.env.NODE_ENV === 'production',
}
